import { Link, useParams } from 'react-router-dom';
import { TableRow, TableCell, Typography, Button, Checkbox } from '@mui/material';
import { PATH_DASHBOARD } from 'src/routes/paths';
import useAppInfoStore from 'src/store/appInfo';
import { useLocalStorage } from 'src/hooks/useLocalStorage';
import Label from 'src/components/Label';
import { MyAvatar } from 'src/components/common';

// ----------------------------------------------------------------------

export default function AppSectionTableRow({
  row,
  rowNumber,
  selected,
  onSelectRow,
  onEditRow,
  onDeleteRow,
  openCloneSectionModal,
  setSelectedSourceAppSectionKey,
}) {
  const { projectId } = useParams();

  const {
    ApplicationSectionLable,
    ApplicationSectionID,
    ApplicationSectionKeyOrder,
    ApplicationSectionTransactionAmountTypeID,
    ApplicationSectionBackgroundImage,
    ApplicationSectionBackgroundImageDark,
    ApplicationSectionBackgroundColor,
    ApplicationSectionBackgroundColorDark,
    ApplicationSectionBackgroundRepeat,
    ApplicationSectionStatus,
  } = row;

  const { appInfo } = useAppInfoStore();
  const currentReward = appInfo?.AmountType?.find((item) => item?.TransactionAmountTypeID === ApplicationSectionTransactionAmountTypeID);

  const [appSectionDetails, setAppSectionDetails] = useLocalStorage('appSectionDetails');

  // const returnRewardValue = () => {
  //   const typeId = currentReward?.TransactionAmountTypeID;
  //   if (typeId === 10 || typeId === 9 || typeId === 5) {
  //     return currentReward?.TransactionAmountTypeLable;
  //   } else if (typeId === 4) return ` ${ApplicationSectionTimeViewVideoToGetBenefit} ثانیه`;
  //   else {
  //     return `${ApplicationSectionTimeViewVideoToGetBenefit} ${currentReward?.TransactionAmountTypeLable}`;
  //   }
  // };

  return (
    <TableRow hover selected={selected}>
      <TableCell padding="checkbox">
        <Checkbox checked={selected} onClick={onSelectRow} />
      </TableCell>

      <TableCell align="center">
        <Typography variant="body1">{rowNumber}</Typography>
      </TableCell>

      <TableCell className="fixed-table-cell" align="center">
        <Typography variant="body1">{ApplicationSectionLable}</Typography>
      </TableCell>

      <TableCell align="center">
        <Typography variant="body1">{ApplicationSectionKeyOrder}</Typography>
      </TableCell>

      <TableCell align="center">
        <div className="flex justify-center">
          <MyAvatar alt={ApplicationSectionLable} src={ApplicationSectionBackgroundImage} />
        </div>
      </TableCell>

      <TableCell align="center">
        <div className="flex justify-center">
          <MyAvatar alt={ApplicationSectionLable} src={ApplicationSectionBackgroundImageDark} />
        </div>
      </TableCell>

      <TableCell align="center">
        {ApplicationSectionBackgroundColor && ApplicationSectionBackgroundColor !== 'transparent' ? (
          <div style={{ backgroundColor: ApplicationSectionBackgroundColor }} className="w-16 h-4 rounded-md mx-auto" />
        ) : (
          '-'
        )}
      </TableCell>

      <TableCell align="center">
        {ApplicationSectionBackgroundColorDark && ApplicationSectionBackgroundColorDark !== 'transparent' ? (
          <div style={{ backgroundColor: ApplicationSectionBackgroundColorDark }} className="w-16 h-4 rounded-md mx-auto" />
        ) : (
          '-'
        )}
      </TableCell>

      <TableCell align="center">
        <Label variant="ghost" sx={{ textTransform: 'capitalize' }} color={ApplicationSectionBackgroundRepeat === 1 ? 'success' : 'error'}>
          {ApplicationSectionBackgroundRepeat === 1 ? 'فعال' : 'غیرفعال'}
        </Label>
      </TableCell>

      <TableCell align="center">
        <Label
          variant="ghost"
          sx={{ textTransform: 'capitalize' }}
          color={
            ApplicationSectionStatus === 1
              ? 'success'
              : [0, 2]?.includes(ApplicationSectionStatus)
              ? 'error'
              : ApplicationSectionStatus === 3
              ? 'warning'
              : 'default'
          }
        >
          {ApplicationSectionStatus === 1
            ? 'فعال'
            : [0, 2]?.includes(ApplicationSectionStatus)
            ? 'غیرفعال'
            : ApplicationSectionStatus === 3
            ? 'حذف شده'
            : 'منقضی شده'}
        </Label>
      </TableCell>

      {/* <TableCell align="center">
        <Typography variant="body1">{returnRewardValue()}</Typography>
      </TableCell>

      <TableCell align="center">
        <Typography variant="body1">{ApplicationSectionTimeViewVideoAmountBenefit} ثانیه</Typography>
      </TableCell> */}

      <TableCell align="center">
        <div className="flex justify-end gap-2">
          <Button
            size="small"
            color="inherit"
            variant="contained"
            onClick={() => {
              openCloneSectionModal();
              setSelectedSourceAppSectionKey(row?.ApplicationSectionKeyOrder);
            }}
          >
            کپی بخش
          </Button>

          <Link to={PATH_DASHBOARD.general.projectFeedList(+projectId, ApplicationSectionKeyOrder, ApplicationSectionID)}>
            <Button size="small" color="primary" variant="contained">
              مدیریت بخش
            </Button>
          </Link>

          <Link
            onClick={() => setAppSectionDetails(row)}
            to={PATH_DASHBOARD.general.appSectionBannersList(+projectId, ApplicationSectionKeyOrder)}
          >
            <Button size="small" color="warning" variant="contained">
              مدیریت بنرها
            </Button>
          </Link>

          <Button size="small" color="info" variant="contained" onClick={onEditRow}>
            ویرایش
          </Button>

          <Button size="small" color="error" variant="contained" onClick={onDeleteRow}>
            حذف
          </Button>
        </div>
      </TableCell>
    </TableRow>
  );
}
